import { BREAKPOINTS } from 'config/style/breakpoints';
import { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';

export const CREATE_MANUAL_TRAPS_MENU_KEY = 'create-manual-traps';

export const REGIONAL_OVERVIEW_MAP_PADDING = {
  top: 150,
  bottom: 150,
  /*
   * The map canvas spans the full viewport, so the floating list panel ends at
   * 396px across it (64px app nav rail + 12px margin + 320px panel). Add a full
   * 44px marker so the westmost trap lands clear of the panel, not against it.
   */
  left: 440,
  right: 50
};

export const REGIONAL_OVERVIEW_MAP_PADDING_MOBILE = {
  top: 150,
  bottom: 150,
  left: 50,
  right: 50
};

export const getRegionalOverviewMapPadding = () =>
  window.innerWidth <= BREAKPOINTS.MOBILE ? REGIONAL_OVERVIEW_MAP_PADDING_MOBILE : REGIONAL_OVERVIEW_MAP_PADDING;

export const RISK_PRIORITY: Record<RiskLevelEnum, number> = {
  [RiskLevelEnum.HIGH]: 3,
  [RiskLevelEnum.MEDIUM]: 2,
  [RiskLevelEnum.LOW]: 1,
  [RiskLevelEnum.NO_RISK]: 0,
  [RiskLevelEnum.MISSING_CONFIG]: -1
};

export const SIDEBAR_VERTICAL_OFFSET = `35px`;
